import { render, staticRenderFns } from "./SwitchAccount.vue?vue&type=template&id=e57421d2&"
import script from "./SwitchAccount.vue?vue&type=script&lang=ts&"
export * from "./SwitchAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports